function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
function buildStyle(param, param1) {
    var font = param.font, readingDirection = param1.readingDirection, start = param1.start;
    var _obj;
    return {
        wrapper: _objectSpread({}, readingDirection, (_obj = {
            fontWeight: font.base.weight.regular,
            fontSize: font.base.size.l
        }, _defineProperty(_obj, start.margin, 8), _defineProperty(_obj, "fontFamily", font.base.family), _obj))
    };
}
export default function useStyle(isRtl) {
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {
            titleStyles: {}
        };
    }
    var wrapper = builtStyle.wrapper;
    return {
        titleStyles: wrapper
    };
};
